"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (_ref) {
  var max = _ref.max;

  var queue = [];

  var size = function size() {
    return queue.length;
  };

  var enqueue = function enqueue(item) {
    if (size() < max) {
      queue.push(item);
    }
  };

  var dequeue = function dequeue() {
    return queue.shift();
  };

  var dequeueAll = function dequeueAll(fn) {
    while (size() > 0) {
      fn(dequeue());
    }
  };

  return {
    size: size,
    enqueue: enqueue,
    dequeueAll: dequeueAll
  };
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-analytics/build/adapters/tealium/queue.js
 ** module id = 408
 ** module chunks = 0
 **/